import React from "react"
import { Button, Card, CardBody, Table } from "reactstrap"
import { useDispatch, useSelector } from "react-redux"
import DeleteModal from "./DeleteModal"
import EditModal from "./EditModal/"
import CardHeader from "reactstrap/lib/CardHeader"
import { RefreshCcw } from "react-feather"
import { postGetEvents } from "../../api"
import { getSportsConfig } from "../../utility/constants/sportConfig"
import { onPostGetEvents } from "../../utility/Utils"

function EventsTable() {
	const dispatch = useDispatch()
	const { doesntHaveTime, incrementThroughSocket } = getSportsConfig(
		localStorage.getItem("sport")
	)
	const spectate = localStorage.getItem("spectate")

	const { events, isDisconnected, isMatchDone } = useSelector((state) => {
		return {
			events: [...state.events],
			isDisconnected: state.isDisconnected,
			isMatchDone:
				state.penaltiesOrEnd === "done" && state.penaltiesOrEnd === "false",
		}
	})

	const columns = [
		{ title: "", key: "quarter" },
		{ title: "Vrijeme", key: "time" },
		{ title: "Ekipa", key: "team" },
		{ title: "Igrač", key: "playerName" },
		{ title: "Event", key: "event" },
		{ title: "Komentari", key: "comment" },
	]
	if (doesntHaveTime) {
		columns.shift()
		columns.shift()
	}

	const createRows = () => {
		const score = { homeTeam: 0, awayTeam: 0 }
		const rows = []

		events?.forEach((event, rowIndex) => {
			if (event.score) {
				score[event.score.team] += event.score.value
			}

			rows.push(
				<tr key={`eventRow-${rowIndex}`}>
					{columns.map((column, index) => (
						<td key={`eventCell-${rowIndex}-${index}`}>
							{event[column.key]}
						</td>
					))}
					{!incrementThroughSocket && (
						<td>
							{event.score && `${score.homeTeam} - ${score.awayTeam}`}
						</td>
					)}
					{!isMatchDone && !spectate && (
						<>
							<td>
								<EditModal initialEvent={event} />
							</td>
							<td>
								<DeleteModal event={event} />
							</td>
						</>
					)}
				</tr>
			)
		})

		return rows.reverse()
	}

	const refresh = () => {
		const body = {
			sport: localStorage.getItem("sport"),
			game:
				JSON.parse(localStorage.getItem("gameDetails") ?? "{}").gameId ?? "",
		}
		postGetEvents(body).then((response) =>
			onPostGetEvents(body, dispatch, response)
		)
	}

	return (
		<Card>
			<CardHeader>
				<h1 style={{ marginBottom: -4 }}>{spectate ? "Događaji" : "Tablica evenata"}</h1>
				<Button.Ripple
					color={isDisconnected ? "flat-secondary" : "flat-primary"}
					size="sm"
					onClick={refresh}
					disabled={isDisconnected}
				>
					<RefreshCcw />
				</Button.Ripple>
			</CardHeader>
			{events?.length > 0 ? (
				<Table responsive>
					<thead>
						<tr>
							{columns.map((column, index) => (
								<th key={`column-${index}`}>{column.title}</th>
							))}
							{!incrementThroughSocket && <th>Rezultat</th>}
							{!isMatchDone && !spectate && (
								<>
									{/* These two empty headers are for the edit and delete buttons */}
									<th></th>
									<th></th>
								</>
							)}
						</tr>
					</thead>
					<tbody>{createRows()}</tbody>
				</Table>
			) : (
				<CardBody>
					<p>Još nema unesenih eventova</p>
				</CardBody>
			)}
		</Card>
	)
}

export default EventsTable
